export const main_data = {
    titulo: "Línea de tiempo",
    module: "estadoscarga",
    descripcion: "En esta sección se muestra la línea de tiempo de los eventos que se han registrado en el sistema",
    descripcion_2: "Construye la línea de tiempo por cada tipo de servicio por separado"
}

